import { mediaCards } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900">精彩看点</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaCards.map((card) => (
            <div
              key={card.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-video bg-background-200 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-foreground-900/10 group-hover:bg-foreground-900/20 transition-colors duration-200 flex items-center justify-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200 shadow-sm">
                    <i className="ri-play-fill text-2xl md:text-3xl ml-1"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2.5 py-1 bg-foreground-900/70 text-background-50 text-xs font-medium rounded-lg whitespace-nowrap">
                  {card.duration}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <div className="flex items-center gap-2 mt-3">
                  <i className="ri-eye-line text-foreground-400 text-sm"></i>
                  <span className="text-xs text-foreground-400">{card.views}次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}